import React, {useState, useEffect} from 'react'
import {Card, Row, Col, Button, CardBody, InputGroup, Input, InputGroupText, Form, FormGroup, FormFeedback} from 'reactstrap'
import logo from '../Assets/logo.png';
import InputMask from 'react-input-mask'
import {FaPhone} from 'react-icons/fa'
export default function ContactComponent({accentColor, secondaryColor, logoSrc, mainText, setStep, setPhoneNumber, startingHour, endingHour, workingHoursText}){
    const[inputValid, setInputValid] = useState(false);
    const[inputValue, setInputValue] = useState("");
    const[isWorkingHours, setIsWorkingHours] = useState(false);

    useEffect(() => {
        checkIfIsWorkingHours();
    }, [startingHour, endingHour]);

    function checkIfIsWorkingHours(){
        const currentHour = new Date().getHours();
        setIsWorkingHours(currentHour >= startingHour && currentHour < endingHour);
    }

    function validateAndSetPhoneNumber(number){
        
        if(number.length > 1){
            if(!(/^\d+$/.test(number.replace("+", '')))){
                setPhoneNumber('');
                setInputValue('');
                return false;
            }            
        }
        
        if(number.length > 0 && isNaN(parseInt(number[number.length - 1])) && number[number.length - 1] !== '+'){
            return false;
        }
        number = number.replace(/\s/g, '');
        if(number.length === 9 && number[0] !== '0' && number[0] !== '1'){
            setPhoneNumber(number);
            setInputValue(number);
            return true;
        }
        if(number.indexOf('+48') !== -1 && number.length === 12 && number[3] !== '0' && number[3] !== '1' ){
            setPhoneNumber(number);
            setInputValue(number);
            return true;
        } if(number.length > 5 && number[0] === '+' && number.indexOf('+48') === -1){
            setPhoneNumber(number);
            setInputValue(number);
            return true;
        }
        setInputValue(number);
        return false;
    }

    function renderInput(){
        if(inputValid){
            return <Input value={inputValue} valid type="tel" maskChar=" " onChange={(e) => setInputValid(validateAndSetPhoneNumber(e.target.value))} onKeyUp={(e) => setInputValid(validateAndSetPhoneNumber(e.target.value))} tag={InputMask} className="wide-input" 
            mask=""
            ></Input>;
        }else{
            return <Input value={inputValue} invalid type="tel" maskChar=" " onChange={(e) => setInputValid(validateAndSetPhoneNumber(e.target.value))} onKeyUp={(e) => setInputValid(validateAndSetPhoneNumber(e.target.value))} tag={InputMask} className="wide-input" 
            mask=""
            ></Input>;
        }
    }

    return(
        <>
             <Card>
                        <CardBody>
                            <div className="centered-div">
                                <img className="small-logo" src={logoSrc ? logoSrc : logo}></img>
                            </div>                            
                            <div className="centered-div big-text">
                                {mainText}
                            </div>
                            <div className="centered-div">
                            <Form>
                                <FormGroup>
                                    <InputGroup>
                                        <InputGroupText><FaPhone color={accentColor}></FaPhone></InputGroupText>
                                        {renderInput()}
                                        <FormFeedback>Podaj prawidłowy numer telefonu</FormFeedback>
                                    </InputGroup>    
                                    
                                </FormGroup>
                            </Form>
                            </div> 
                            <Row className="button-strip">
                                <Col>
                                    <Button disabled={!isWorkingHours} onClick={() => {checkIfIsWorkingHours(); if(inputValid && isWorkingHours){ setStep("end") }}} style={{backgroundColor: accentColor, color: secondaryColor}} className="mr-2">Zadzwoń teraz</Button>
                                </Col>
                                <Col>
                                    <Button onClick={() => { if(inputValid){ setStep("date") }}} style={{backgroundColor: accentColor, color: secondaryColor}} className="btn-space">Zadzwoń później</Button>    
                                </Col>
                            </Row>
                            <div style={{display: !isWorkingHours ? 'block' : 'none'}} className="centered-div">
                                {workingHoursText}
                            </div>
                        </CardBody>                        
                    </Card>
        </>
    )
}